<template lang="pug" functional>
ul.nav-list
  slot(name="subListMobile")

  list-item(
    class="nav-item"
    v-for="item, index in items"
    :text="item.text"
    :items="item.children"
    :to="item.to"
    :external="item.external"
    :callback="item.callback"
    :key="index"
    :level="level"
    :max-level="maxLevel"
  )
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    items: {
      type: Array,
      default: () => [],
    },

    level: {
      type: Number,
      default: 1,
    },

    maxLevel: {
      type: Number,
      required: false,
    },

    small: {
      type: Boolean,
      default: false
    },

    compact: {
      type: Boolean,
      default: false,
    }
  }
})

export default class List extends Vue {
  beforeCreate() {
    this.$options.components.ListItem = require('./SubItem.vue');
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'

.nav-list
  position absolute
  margin-left 0
  list-style-type none
  display block
  z-index 9
  min-width 200px
  width 100%
  font-size 10px
  line-height 12px
  padding 10px 0
  text-align left
  background #fff
  border 2px solid #8593e9
  +phone()
    position fixed
    margin-left 0
    top 0
    left 0
    width 80vw
    bottom 0
    padding-right 60px

</style>



// WEBPACK FOOTER //
// SubList.vue?1f1989ad